module.exports = ".font-clr {\n    font-size: 60px !important;\n    color: #4285f4;\n}\n\n.mdi-plus-circle,\n.mdi-minus-circle {\n    color: #b9baba;\n}"